// libs
import React, { useEffect } from 'react';
// widgets
import Table from '@/widgets/Table';
import ProductTableRow from './widgets/Row';
// styles
import productStyle from './ProductTable.module.scss';
// helpers
import { PRODUCT_TABLE_COLUMNS } from '@/pages/instamart/campaign/details/helpers';
const transformProductToTable = (productData) => {
    const tableData = productData.map((product) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        const variants = ((_a = product.attributes) === null || _a === void 0 ? void 0 : _a.variants) || [];
        const variantsDescriptions = variants.map((variant) => variant.description);
        return {
            id: product.id,
            name: ((_b = product.attributes) === null || _b === void 0 ? void 0 : _b.title) || '',
            impression: (_c = product.metrics) === null || _c === void 0 ? void 0 : _c.impressions,
            gmv: (_d = product.metrics) === null || _d === void 0 ? void 0 : _d.gmv,
            addToCart: (_e = product.metrics) === null || _e === void 0 ? void 0 : _e.addToCart,
            roi: (_f = product.metrics) === null || _f === void 0 ? void 0 : _f.roi,
            spend: (_g = product.metrics) === null || _g === void 0 ? void 0 : _g.budgetBurnt,
            creativeId: ((_h = product.attributes) === null || _h === void 0 ? void 0 : _h.creativeId) || '',
            variants: variantsDescriptions,
        };
    });
    return tableData;
};
const ProductTable = ({ productData, mode, onDelete, preSelectedProducts, showHeader, stale, }) => {
    if (!productData)
        return null;
    const [tableData, setTableData] = React.useState([]);
    useEffect(() => {
        // @ts-expect-error: needs to work on
        setTableData(transformProductToTable(productData));
    }, [productData]);
    const sortHandler = (sortData) => {
        const newData = [...tableData];
        if (sortData.sortBy === 'products') {
            newData.sort((a, b) => a.name.localeCompare(b.name));
        }
        else {
            newData.sort((a, b) => {
                const aValue = a[sortData.sortBy] || 0;
                const bValue = b[sortData.sortBy] || 0;
                if (sortData.descending) {
                    return bValue - aValue;
                }
                else {
                    return aValue - bValue;
                }
            });
        }
        setTableData([...newData]);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Table, { classNames: {
                container: productStyle.table,
            }, columns: PRODUCT_TABLE_COLUMNS, data: tableData, showHeader: showHeader, renderRow: (row, index) => {
                return (React.createElement(ProductTableRow, { key: index, mode: mode, row: row, stale: stale, preSelectedProducts: preSelectedProducts, onDelete: onDelete }));
            }, onSort: sortHandler })));
};
export default ProductTable;
